import { datadogRum } from "@datadog/browser-rum";
import { fetchConfig } from "./hooks/use-config";

export const initializeDatadog = async (): Promise<void> => {
  const config = await fetchConfig();

  // Initialize Datadog RUM (Real User Monitoring)
  datadogRum.init({
    applicationId: config.datadogConfig.applicationId,
    clientToken: config.datadogConfig.clientToken,
    site: "datadoghq.eu",
    service: "color-finder",
    env: config.datadogConfig.env,
    version: "1.0.0",
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: "allow",
    trackingConsent: "not-granted",
    trackBfcacheViews: true,
  });

  // Start collecting RUM data
  datadogRum.startSessionReplayRecording();
};

// Grant or revoke tracking consent
export const handleTrackingConsent = (consent: boolean): void => {
  datadogRum.setTrackingConsent(consent ? "granted" : "not-granted");
};

// Helper function to log custom events
export const logCustomEvent = (
  eventName: string,
  properties: Record<string, unknown> = {},
): void => {
  datadogRum.addAction(eventName, properties);
};

// Helper function to log errors
export const logError = (
  error: Error,
  context: Record<string, unknown> = {},
): void => {
  datadogRum.addError(error, context);
};

export type DatadogUserType = "internal" | "external";

// Set user identity for tracking real users
export const setUserIdentity = (
  email: string,
  userType: DatadogUserType,
  name?: string,
  id?: string,
): void => {
  datadogRum.setUser({
    email,
    name,
    id: id || email,
    user_type: userType,
  });
};
